import { UilUsersAlt, UilCheckSquare, UilEnvelope, UilFileAlt, UilApps, UilStar, UilClock, UilArrowUpRight } from '@iconscout/react-unicons';
import { Menu } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import UilEllipsisV from '@iconscout/react-unicons/icons/uil-ellipsis-v';
import propTypes from 'prop-types';
import { getBasePathByRole } from '../utility/rolePath';


function MenuItems({ toggleCollapsed }) {
  const { t } = useTranslation();

  function getItem(label, key, icon, children, type) {
    return {
      key,
      icon,
      children,
      label,
      type,
    };
  }

  const { topMenu } = useSelector((state) => {
    return {
      topMenu: state.ChangeLayoutMode.topMenu,
    };
  });

  // const path = '/admin';
  const path = getBasePathByRole();


  const pathName = window.location.pathname;
  const pathArray = pathName.split(path);
  const mainPath = pathArray[1];
  const mainPathSplit = mainPath.split('/');

  const [openKeys, setOpenKeys] = React.useState(
    !topMenu ? [`${mainPathSplit.length > 2 ? mainPathSplit[1] : 'dashboard'}`] : [],
  );

  const onOpenChange = (keys) => {
    setOpenKeys(keys[keys.length - 1] !== 'recharts' ? [keys.length && keys[keys.length - 1]] : keys);
  };

  const onClick = (item) => {
    if (item.keyPath.length === 1) setOpenKeys([]);
  };

  const items = [
    getItem(
      <NavLink onClick={toggleCollapsed} to={`${path}/task-manager`}>
        {t('Tasks')}
      </NavLink>,
      'Task Manager', !topMenu && <UilFileAlt />,
      null
    ),
    getItem(
      <NavLink onClick={toggleCollapsed} to={`${path}/employeedailywork`}>
        {t('Daily Updates')}
      </NavLink>,
      'LeaveRequestManage', !topMenu && <UilCheckSquare />,
      null
    ),
    getItem(
      <NavLink onClick={toggleCollapsed} to={`${path}/leaverequestmanage`}>
        {t('Leave Management')}
      </NavLink>,
      '', !topMenu && <UilCheckSquare />,
      null
    ),
    getItem(
      <NavLink onClick={toggleCollapsed} to={`${path}/todo`}>
        {t('To Do')}
      </NavLink>,
      'Todo', !topMenu && <UilCheckSquare />,
      null
    ),
    getItem(
      <NavLink onClick={toggleCollapsed} to={`${path}/leavecalender`}>
        {t('Calender')}
      </NavLink>,
      'LeaveCalender', !topMenu && <UilCheckSquare />,
      null
    ),
    getItem(
      <NavLink onClick={toggleCollapsed} to={`${path}/employees`}>
        {t('Employees')}
      </NavLink>,
      'Employees', !topMenu && <UilUsersAlt />,
      null
    ),
    getItem(
      <NavLink onClick={toggleCollapsed} to={`${path}/designations`}>
        {t('Designations')}
      </NavLink>,
      'Designations', !topMenu && <UilStar />,
      null
    ),
    getItem(
      <NavLink onClick={toggleCollapsed} to={`${path}/projects`}>
        {t('Projects')}
      </NavLink>,
      'Projects', !topMenu && <UilApps />,
      null
    ),

    getItem(
      <NavLink onClick={toggleCollapsed} to={`${path}/product`}>
        {t('Products')}
      </NavLink>,
      'Product', !topMenu && <UilApps />,
      null
    ),
    getItem(
      <NavLink onClick={toggleCollapsed} to={`${path}/addleave`}>
        {t('Add/Leaves management')}
      </NavLink>,
      'addleave', !topMenu && <UilApps />,
      null
    ), getItem(
      <NavLink onClick={toggleCollapsed} to={`${path}/teamgroup`}>
        {t('Team Group')}
      </NavLink>,
      'Team Group', !topMenu && <UilUsersAlt />,
      null
    ),



    // getItem(
    //   <NavLink onClick={toggleCollapsed} to={`${path}/today-progress`}>
    //     {t('Day Wise Progress')}
    //   </NavLink>,
    //   'Day Wise Progress', !topMenu && <UilClock />,
    //   null
    // ),
    getItem(
      <NavLink onClick={toggleCollapsed} to={`${path}/compose-mail`}>
        {t('Leave')}
      </NavLink>,
      'Compose Mail', !topMenu && <UilEnvelope />,
      null
    ),


    getItem(
      <NavLink onClick={toggleCollapsed} to={`${path}/requirements`}>
        {t('Requirements')}
      </NavLink>,
      'Requirements', !topMenu && <UilArrowUpRight />,
      null
    ),


  ];

  return (
    <Menu
      onOpenChange={onOpenChange}
      onClick={onClick}
      mode={!topMenu || window.innerWidth <= 991 ? 'inline' : 'horizontal'}
      defaultSelectedKeys={
        !topMenu
          ? [
            `${mainPathSplit.length === 1 ? 'dashboard' : mainPathSplit.length === 2 ? mainPathSplit[1] : mainPathSplit[2]
            }`,
          ]
          : []
      }
      defaultOpenKeys={!topMenu ? [`${mainPathSplit.length > 2 ? mainPathSplit[1] : 'dashboard'}`] : []}
      overflowedIndicator={<UilEllipsisV />}
      openKeys={openKeys}
      items={items}
    />
  );
}

MenuItems.propTypes = {
  toggleCollapsed: propTypes.func,
};

export default MenuItems;
